import { render, staticRenderFns } from "./textoeimg.vue?vue&type=template&id=4c7d0c90&"
import script from "./textoeimg.vue?vue&type=script&lang=js&"
export * from "./textoeimg.vue?vue&type=script&lang=js&"
import style0 from "./textoeimg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports